module.exports = __webpack_public_path__ + "static/media/CSS3.c26a73b4.png";